<template>
  <div :class="[row ? 'flex items-center flex-wrap gap-4' : '', 'group']">
    <label
      v-if="!noLabel"
      :for="name"
      :class="[
        !ghostLabel
          ? 'dark:text-gray-300 text-primary font-medium'
          : required
            ? 'text-primary dark:text-gray-300 font-semibold'
            : 'text-gray-700 dark:text-gray-200 font-normal',
        row ? '' : 'mb-2',
        { 'pl-4': !reverse },
      ]"
      class="flex items-center gap-1 pl-4 text-sm"
    >
      {{ $t(label || '') }}
      <span v-if="required" class="text-danger dark:text-danger text-lg leading-0"> * </span>
      <tippy v-if="tooltip" class="flex items-center justify-center">
        <BaseIcon
          name="info"
          class="text-gray-400 group-hover:text-success hover:ring-success text-[18px] base-transition"
        />
        <template #content>
          <slot name="tooltip">{{ $t(tooltip || '') }}</slot>
        </template>
      </tippy>
    </label>
    <div
      class="pl-1 md:pl-0"
      :class="[
        { 'order-first': reverse },
        rowRadio
          ? 'flex items-center gap-3 '
          : size
            ? 'grid grid-cols-1 gap-4'
            : ' grid grid-cols-1 gap-1',
        rowRadio && !row ? 'lg:pt-2.5' : '',
      ]"
    >
      <BaseRadio
        v-for="item in list"
        :key="item.id"
        type="radio"
        :type-view="type"
        :id="item.id"
        :name="item.name"
        :value="item.value"
        :size="size"
        :label="item.label"
        :modelValue="modelValue"
        :disabled="disabled || item.disabled"
        @update:modelValue="$emit('update:modelValue', $event)"
      />
    </div>
    <div v-if="!hideErrors" :class="[' pl-4 mb-2', { 'h-5': !denseError }]">
      <ErrorMessage
        :name="name"
        v-slot="{ message }"
        class="text-danger dark:text-danger text-xs"
        as="span"
      >
        {{ $t(message || '') }}
      </ErrorMessage>
    </div>
  </div>
</template>

<script>
import { ErrorMessage } from 'vee-validate';
import BaseRadio from './BaseRadio.vue';

export default {
  components: { BaseRadio, ErrorMessage },
  props: {
    label: String,
    name: String,
    type: {
      type: String,
      default: 'radio',
    },
    id: String,
    placeholder: String,
    value: {
      type: [Boolean, String, Number],
      default: null,
    },
    modelValue: {
      type: [Boolean, String, Number],
      default: true,
    },
    row: {
      type: Boolean,
      default: false,
    },
    rowRadio: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    btn: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    list: {
      type: [Array, Object],
      default: () => [],
    },
    check: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: [String, Boolean],
      default: false,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    hideErrors: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    denseError: {
      type: Boolean,
      default: false,
    },
    ghostLabel: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
};
</script>

<style scoped></style>
